'use client';

// ─────────────────────────────────────────────────────────────────────────────
// TicketsTab — triage surface for everything routed to the merged PM/QC role.
//
// Composes:
//   1. TicketsWidget — high/medium/low filter, AI scoring, SLA breach badges,
//      "View all tickets" modal. Owns its own `tickets_realtime` subscription.
//   2. MergedEscalationsPanel — the unified PM + QC escalations list with
//      source tags (PM / QC). Replaces the two separate sections that used
//      to live on DashboardInteractive (PM Escalations) and inside
//      QCInspectionPanel (QC Escalations).
//   3. NotificationsAlertsWidget — Daily Briefing / Materials / Approvals
//      sub-tabs. Owns its own fetch.
//
// The orchestrator passes `onEscalation` so TicketsWidget can launch the
// existing iframe-based Escalation Management slideover.
// ─────────────────────────────────────────────────────────────────────────────

import TicketsWidget from '../TicketsWidget';
import NotificationsAlertsWidget from '../NotificationsAlertsWidget';
import MergedEscalationsPanel from '../MergedEscalationsPanel';

interface TicketsTabProps {
  onEscalation: () => void;
}

export default function TicketsTab({ onEscalation }: TicketsTabProps) {
  return (
    <div className="space-y-5">
      <div className="min-h-[420px]">
        <TicketsWidget onEscalationClick={onEscalation} />
      </div>
      <MergedEscalationsPanel onOpenEscalationModal={onEscalation} />
      <div className="min-h-[420px]">
        <NotificationsAlertsWidget />
      </div>
    </div>
  );
}
